



































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { IntroItem } from "@/common/interface";
import { replaceString } from "@/common/utils/dealWithString";
import fetch from "@/common/api/fetch";

const loadingImage = require("@/assets/img/loadingImage.gif");

@Component
export default class IndexInstitutionIntroList extends Vue {
  @Getter("institutionIntros") getterInstitutionIntros!: Array<IntroItem>;
  @Getter("section") section!: object;

  loadingImage: string = loadingImage;

  get institutionIntros(): Array<IntroItem> {
    const tempArray: Array<IntroItem> = [];
    for (
      let i: number = 0, length: number = this.getterInstitutionIntros.length;
      i < length;
      i++
    ) {
      const item: IntroItem = Object.assign(
        {},
        this.getterInstitutionIntros[i]
      );
      item.value = item.value && replaceString(item.value);
     
      tempArray.push(item);
    }
    return tempArray;
  }
  
  handleVideo(item: any) {
    fetch.parseUrl(item.value).then((res: any) => {
      const query = {
        url: res || item.value
      };
      this.$router.push({
        name: "video",
        query: query
      });
    });
  }
}
